/* Hide only Shopify Inbox's launcher while scrolling down on mobile, across the storefront. */
(() => {
  if (window.eliteGuideChatLoaded) return;
  const content = document.getElementById('elite-grind-guide') || document.querySelector('main') || document.body;
  window.eliteGuideChatLoaded = true;
  const mobile = matchMedia('(max-width: 767px)');
  const style = document.createElement('style');
  style.textContent = '@media(max-width:767px){html.elite-guide-chat-hidden shopify-chat::part(activator),html.elite-guide-chat-hidden shopify-agent-runtime::part(activator){opacity:0!important;visibility:hidden!important;pointer-events:none!important}}';
  document.head.appendChild(style);
  let lastY = scrollY;
  let direction = 0;
  let distance = 0;
  let queued = false;
  const show = () => document.documentElement.classList.remove('elite-guide-chat-hidden');
  function update() {
    queued = false;
    const y = Math.max(0, scrollY);
    const delta = y - lastY;
    lastY = y;
    const rect = content.getBoundingClientRect();
    if (!mobile.matches || y < 100 || rect.bottom <= innerHeight + 40 || rect.top >= innerHeight) {
      show(); distance = 0; return;
    }
    if (!delta) return;
    const nextDirection = Math.sign(delta);
    if (nextDirection !== direction) distance = 0;
    direction = nextDirection;
    distance += Math.abs(delta);
    if (distance >= 12) {
      document.documentElement.classList.toggle('elite-guide-chat-hidden', direction > 0);
      distance = 0;
    }
  }
  addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  addEventListener('resize', update, { passive: true });
  mobile.addEventListener('change', update);
  // Preserve keyboard access when focus reaches any control inside the widget.
  document.addEventListener('focusin', event => {
    if (event.composedPath().some(node => node.tagName === 'SHOPIFY-CHAT' || node.tagName === 'SHOPIFY-AGENT-RUNTIME')) show();
  });
})();
